<template>
  <section class="section packages" id="packages">
    <div class="shell">
      <div class="section-top">
        <div>
          <span class="eyebrow light-eyebrow">ГОТОВЫЕ КОНФИГУРАЦИИ</span>
          <h2>Всё нужное<br /><span class="muted">В одной системе</span></h2>
        </div>
        <p class="section-intro">
          Оборудование и монтаж Robotics Vision.<br />Цены из каталога и состав,<br />который можно
          изменить.
        </p>
      </div>
      <div class="package-grid">
        <article class="package-card">
          <span class="tiny-label">КОМПАКТНЫЙ ОБЪЕКТ</span>
          <h3>Точка обзора</h3>
          <p>Магазин, небольшой офис или дом.</p>
          <div class="camera-count">
            <strong>4</strong><span>IP-камеры<br />в одной системе</span
            ><span class="count-symbol" aria-hidden="true">◉</span>
          </div>
          <div class="package-price">
            <small>оборудование и монтаж</small><strong>{{ typicalPrice(4) }}</strong>
          </div>
          <ul class="check-list">
            <li>Камеры и PoE-коммутатор</li>
            <li>Сервер и диск для архива</li>
            <li>Кабель и подключение к вашему роутеру</li>
            <li>Предварительный монтаж и настройка</li>
          </ul>
          <button class="button button-dark" @click="choose('4')">Выбрать 4 камеры</button>
        </article>
        <article class="package-card featured">
          <span class="package-badge">БОЛЬШЕ В ПОЛЕ ЗРЕНИЯ</span
          ><span class="tiny-label">НЕСКОЛЬКО ЗОН</span>
          <h3>Полная картина</h3>
          <p>Торговый зал, склад и другие помещения.</p>
          <div class="camera-count">
            <strong>8</strong><span>IP-камер<br />в одной системе</span
            ><span class="count-symbol" aria-hidden="true">◉</span>
          </div>
          <div class="package-price">
            <small>оборудование и монтаж</small><strong>{{ typicalPrice(8) }}</strong>
          </div>
          <ul class="check-list">
            <li>8 IP-камер для помещений и PoE-коммутатор</li>
            <li>Сервер и диск для архива всех камер</li>
            <li>Кабель и подключение к вашему роутеру</li>
            <li>Монтаж, настройка и единый доступ</li>
          </ul>
          <button class="button button-primary" @click="choose('8')">Выбрать 8 камер</button>
        </article>
        <article class="package-card custom-package">
          <span class="tiny-label">ВАША ЗАДАЧА</span>
          <h3>Особый ракурс</h3>
          <p>Когда типовой комплект не подходит.</p>
          <div class="custom-symbol" aria-hidden="true">
            <span>+</span><span>+</span><span>+</span><span>+</span>
          </div>
          <h4>Начнём с объекта</h4>
          <p>
            Спроектируем систему под планировку, освещение, срок хранения и уже установленное
            оборудование.
          </p>
          <ul class="check-list">
            <li>Индивидуальный подбор камер</li>
            <li>Проверка совместимости</li>
            <li>Смета до начала работ</li>
          </ul>
          <button class="button button-outline-dark" @click="choose('custom')">
            Собрать свой проект
          </button>
        </article>
      </div>
      <p class="pricing-note">
        Предварительная стоимость для типового магазина: архив 7 дней по 14 часов в сутки, ваш
        роутер, монтаж и настройка включены. Можно выбрать режим без архива или добавить новый
        роутер в расчёте. Измените модели и параметры в конструкторе. Сложные работы и
        дополнительные расходные материалы уточняются по объекту.
      </p>
    </div>
  </section>
</template>
<script setup lang="ts">
import type { EstimateCameras } from '~/composables/useEstimate';
const { selection, typicalPrice, prepare } = useEstimate();
function choose(cameras: EstimateCameras) {
  selection.value.cameras = cameras;
  selection.value.object = 'business';
  selection.value.includeArchive = true;
  selection.value.includeRouter = false;
  prepare();
  navigateTo('/calculator');
}
</script>
